import { bemComponent } from '@99designs/utils/app';

export default bemComponent('marketing-icon', 'MarketingIcon');



// WEBPACK FOOTER //
// ./src/web/js/contest/components/marketing-icon.jsx